import React from 'react';

import { useGetOpenDrawer } from 'common/hooks/drawer';
import { useLocalization } from 'common/providers/LocaleProvider';
import ConfigurationTrapDrawerBody from '../ConfigurationTrapBody';
import { trackDrawerClose } from '../tracking';
import type { OpenDrawerOptions } from '../types';

export const useOpenConfigurationTrap = () => {
  const openDrawer = useGetOpenDrawer();
  const { r, t } = useLocalization();

  return ({ title, ...options }: OpenDrawerOptions) => {
    openDrawer({
      title,
      onCloseComplete: trackDrawerClose,
      withBackButton: true,
      backButtonAriaLabel: r.t('h24_drawer_back_button', {
        backTo: t('h24_variations_drawer_label'),
      }),
      content: <ConfigurationTrapDrawerBody title={title} {...options} />,
    });
  };
};
